


































import Vue from 'vue';
import LogResultPanel from '@/parts/labor/LogResultPanel.vue';
import LaborCalendar from '@/parts/labor/LaborCalendar.vue';

export default Vue.extend({
    name: 'DebugLogResultPanel',

    components: {
      LogResultPanel, LaborCalendar,
    },
});
